/**
 * The floating "Get it now" pill.
 *
 * Up when the hero is behind you; down again over the section it points at and
 * over the footer. Ported from the prototype, which worked the same way — the
 * two exceptions are the design, not tidying.
 *
 * The scroller is found rather than assumed, for the reason
 * assets/pruvit-header.js gives at length: Horizon does not scroll the document
 * above 990px, .page-wrapper does, and crossing that breakpoint moves it. A
 * listener on window there fires nothing at all.
 */
(function () {
  var pill = document.querySelector('[data-pruvit-fcta]');
  if (!pill) return;

  var target = document.getElementById(pill.dataset.target || '');
  var hero = document.querySelector('[data-pruvit-hero], .pruvit-hero');
  var foot = document.querySelector('footer');

  // Nothing to be past and nothing to point at: a pill that can never stand
  // down is the furniture this is written to avoid.
  if (!hero || !target) return;

  pill.hidden = false;

  var scroller = null;

  function findScroller() {
    var node = pill.parentElement;
    while (node && node !== document.body) {
      var overflowY = getComputedStyle(node).overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') return node;
      node = node.parentElement;
    }
    return window;
  }

  function onScroll() {
    var viewportH = window.innerHeight;

    // Geometry from the elements themselves rather than a scroll offset, so
    // this is right whichever thing is scrolling and whatever the header is
    // doing above it.
    var pastHero = hero.getBoundingClientRect().bottom <= 0;

    var t = target.getBoundingClientRect();
    var targetOnScreen = t.top < viewportH && t.bottom > 0;

    var atFoot = foot ? foot.getBoundingClientRect().top < viewportH : false;

    pill.classList.toggle('is-on', pastHero && !targetOnScreen && !atFoot);
  }

  function bind() {
    var next = findScroller();
    if (next === scroller) return;
    if (scroller) scroller.removeEventListener('scroll', onScroll);
    scroller = next;
    scroller.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  bind();
  window.addEventListener('resize', bind, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('load', onScroll);
})();
